
// interface Dictionary<T> {
//     [Key: string]: T;
// }

import {showToastr} from "./showToastr";
import {IActionBase} from "./IActionBase";
import {navigateToPage} from "./navigate-to-page";
import {executeQuery} from "./executeQuery";
import {save} from "./save";
import {IValidateBase} from "../validations/IValidateBase";
import {Confirmation} from "./confirmation";
import {ServerAction_CallGeneralAction} from "./ServerAction_CallGeneralAction";
import {action_AP_SetElementData} from "./action_AP_SetElementData";
import {setValues} from "./setValues";
import {action_AP_ShowModal} from "./action_AP_ShowModal";
import {action_AP_DuplicateSingleRow} from "./action_AP_DuplicateSingleRow";
import {action_AP_ExecuteElementCommand} from "./action_AP_ExecuteElementCommand";
import {reloadCurrentPage} from "./reloadCurrentPage";
import {action_Tasker_SetStartDateTillToday} from "../../applyooProjects/taskeem/actions/action_Tasker_SetStartDateTillToday";
import {action_AP_Kendo_GetSelectedRows} from "./action_AP_Kendo_GetSelectedRows";
import {action_AP_RefreshRepository} from "./action_AP_RefreshRepository";
import {action_Tasker_ClearDataAfterDuplicateTask} from "./action_Tasker_ClearDataAfterDuplicateTask";
import {action_AP_FireRefreshDataEvent} from "./action_AP_FireRefreshDataEvent";
import {action_AP_ExecutePageTrigger} from "./action_AP_ExecutePageTrigger";
import {action_AP_LockUnlockElements} from "./action_AP_LockUnlockElements";
import {action_AP_ValidateForm} from "./action_AP_ValidateForm";

//import {TriggersManager} from "./triggersManager";

export class ActionsManager {
    dicActions: { [name: string]: IActionBase } = {};
    dicValidation: { [name: string]: IValidateBase } = {};
    //viewPage:any;
    //triggersManager:TriggersManager = new TriggersManager();
    dicIgnoredActions:any  = {};


    constructor(){
        //this.triggersManager = new TriggersManager();

        this.dicIgnoredActions={
            "action_AP_GetFiltersFromLocalStorage": true,
        }

        this.dicActions["showToastr"] = new showToastr({});
        // this.dicActions["navigateToPage"] = navigateToPage.prototype;
        this.dicActions["navigateToPage"] = new navigateToPage({});
        this.dicActions["executeQuery"] = new executeQuery({});
        this.dicActions["reloadCurrentPage"] = new reloadCurrentPage({});
        this.dicActions["save"] = new save({});
         this.dicActions["action_AP_Confirmation"] = new Confirmation({});
         this.dicActions["setValues"] = new setValues({});
         this.dicActions["action_AP_ShowModal"] = new action_AP_ShowModal({});
         this.dicActions["action_AP_ExecuteElementCommand"] = new action_AP_ExecuteElementCommand({});
         this.dicActions["ServerAction_CallGeneralAction"] = new ServerAction_CallGeneralAction({});
        // this.dicActions["action_AP_DeleteLocalStorageKey"] = new action_AP_DeleteLocalStorageKey({});
        this.dicActions["action_AP_SetElementData"] = new action_AP_SetElementData({});
        this.dicActions["action_AP_DuplicateSingleRow"] = new action_AP_DuplicateSingleRow({});
        this.dicActions["action_Tasker_SetStartDateTillToday"] = new action_Tasker_SetStartDateTillToday({});
        this.dicActions["action_AP_Kendo_GetSelectedRows"] = new action_AP_Kendo_GetSelectedRows({});
        this.dicActions["action_AP_RefreshRepository"] = new action_AP_RefreshRepository({});
        this.dicActions["FireRefreshDataEvent"] = new action_AP_FireRefreshDataEvent({});

        this.dicActions["action_AP_LockUnlockElements"] = new action_AP_LockUnlockElements({});
        this.dicActions["ExecutePageTrigger"] = new action_AP_ExecutePageTrigger({});
        this.dicActions["action_AP_ValidateForm"] = new action_AP_ValidateForm({});

        //Taskeem Actions
        this.dicActions["action_Tasker_ClearDataAfterDuplicateTask"] = new action_Tasker_ClearDataAfterDuplicateTask({});

        //this.dicValidation["AP_Validation_Email"] = new AP_Validation_Email();
        //this.dicValidation["AP_Validation_Grid"] = new AP_Validation_Grid();
        //this.dicValidation["AP_Validation_IpAddress"] = new AP_Validation_IpAddress();
        //this.dicValidation["AP_Validation_MaxDate"] = new AP_Validation_MaxDate();
        //this.dicValidation["AP_Validation_MaxLength"] = new AP_Validation_MaxLength();
        //this.dicValidation["AP_Validation_MaxValue"] = new AP_Validation_MaxValue();
        //this.dicValidation["AP_Validation_MinDate"] = new AP_Validation_MinDate();
        // this.dicValidation["AP_Validation_MinLength"] = new AP_Validation_MinLength();
        // this.dicValidation["AP_Validation_MinValue"] = new AP_Validation_MinValue();
        // this.dicValidation["AP_Validation_Number"] = new AP_Validation_Number();
        //this.dicValidation["AP_Validation_Recurrence"] = new AP_Validation_Recurrence();
        //this.dicValidation["AP_Validation_Required"] = new AP_Validation_Required();
    }

    executeActions(prmLstActions: any, prmElementObj?:any, prmDataObj?:any) {
        if (prmLstActions && this.dicActions){
            for (let ind01 = 0; ind01 < prmLstActions.length; ind01++) {
                const currAction = prmLstActions[ind01];

                const currActionInstance = this.dicActions[currAction.ActionTypeCode];

                // switch (currAction.ActionTypeCode){
                //     case "save":
                //         store.dispatcconh({type:'SET_ACTIONS', lstActions: [{"actionCode": "validateQuery", "actionParams": currAction?.ActionParameters}]});
                //         store.dispatch({type:'SET_ACTIONS', lstActions: [{"actionCode": "saveData", "actionParams": currAction?.ActionParameters}]});
                //         break;
                //
                //     case "executeQuery":
                //         store.dispatch({type:'SET_ACTIONS', lstActions: [{"actionCode": "dataRequest_Get", "actionParams": {queryName: ""}}]});
                //         break;
                // }

                // if (currAction.ActionTypeCode == "save"){
                //     store.dispatch({type:'SET_ACTIONS', lstActions: [{"actionCode": "validateQuery", "actionParams": currAction?.ActionParameters}]});
                // }
                //Comment : for checking
                // if(ind01===0) {
                //
                //     const currActionInstance1 = this.dicActions["action_AP_DuplicateSingleRow"];
                //     if (currActionInstance1) {
                //         currActionInstance1.Execute(currAction.ActionParameters, this, prmElementObj)
                //     }
                // }
                if (currActionInstance){
                    currActionInstance.Execute(currAction.ActionParameters, this, prmElementObj,prmDataObj)
                }
                else {
                    if (!this.dicIgnoredActions[currAction.ActionTypeCode]){
                        let lstKnownActionTypeCodes:any =
                            ['action_AP_ReloadPageHost', 'action_AP_RefreshElementData', 'action_AP_HideElement', 'ExecutePageTrigger', 'IfStatement']

                        if (!lstKnownActionTypeCodes?.includes(currAction.ActionTypeCode)) {
                           // alert(currAction.ActionTypeCode);
                        }
                    }
                }
            }

        }
        // alert("aaa");
    }

    // Validate(prmQueryname?: string) {
    //     let currPageStruct = store.getState().store_PageStructure()
    //
    //     let lstValidateElements = currPageStruct.lstElements.filter((prmElement: any) => {
    //         return !!prmElement.DataBindStr
    //             && (!prmQueryname || prmElement.DataBindStr.startswith(prmQueryname));
    //     });
    //
    //     if (lstValidateElements.length > 0 && this.dicValidation){
    //         for (let ind01 = 0; ind01 < lstValidateElements.length; ind01++) {
    //             const currElementObj = lstValidateElements[ind01];
    //
    //             // const currValidationInstance = this.dicValidation[currValidationObj.validateCode];
    //             //
    //             // if (currValidationInstance){
    //             //     currValidationInstance.Validate(prmElementObj)
    //             // }
    //         }
    //     }
    //     // alert("inside ValidationManager")
    // }
}
